import { render, staticRenderFns } from "./ModalMessenger.vue?vue&type=template&id=25819fb7"
import script from "./ModalMessenger.vue?vue&type=script&lang=js"
export * from "./ModalMessenger.vue?vue&type=script&lang=js"
import style0 from "./ModalMessenger.vue?vue&type=style&index=0&id=25819fb7&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports